import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RegistrationComponent } from './components/registration/registration.component';
import { ChooseLangComponent } from './components/choose-lang/choose-lang.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule, MatLabel, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { DrawSurfaceComponent } from './components/draw-surface/draw-surface.component';
import {MatCardModule} from '@angular/material/card';
import { AgreeDialogComponent } from './components/agree-dialog/agree-dialog.component';
import { RouterModule } from '@angular/router';
import { InfoDialogComponent } from './components/info-dialog/info-dialog.component';
import { LoaderComponent } from './components/loader/loader.component';
import { SuccessComponent } from './components/success/success.component';
import { LandingComponent } from './components/admin/landing/landing.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { environment } from 'src/environments/environment';
import * as firebase from 'firebase';
import { LoginComponent } from './components/admin/login/login.component';
import { ReportsMainComponent } from './components/admin/reports-main/reports-main.component';
import { MemberListComponent } from './components/admin/member-list/member-list.component';
import { MatTreeModule } from '@angular/material/tree';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { AuthInterceptor } from './interceptors/auth-interceptor';
import { ApiErrorWarningInterceptor } from './interceptors/api-error-warning-interceptor';
import { MatSortModule } from '@angular/material/sort';
import { MemberStatsComponent } from './components/admin/member-stats/member-stats.component';
import { AppMessagesComponent } from './components/admin/app-messages/app-messages.component';
import { MarketingChannelsComponent } from './components/admin/marketing-channels/marketing-channels.component';
import { MarketingChannelsDetailComponent } from './components/admin/marketing-channels-detail/marketing-channels-detail.component';
import { AppMessagesDetailComponent } from './components/admin/app-messages-detail/app-messages-detail.component';
import { MemberDetailComponent } from './components/admin/member-detail/member-detail.component';
import { TermsDetailsComponent } from './components/admin/app-messages-detail/terms-details/terms-details.component';
import { GdprDetailsComponent } from './components/admin/app-messages-detail/gdpr-details/gdpr-details.component';
import { MainDetailsComponent } from './components/admin/app-messages-detail/main-details/main-details.component';
import { DataDeleteComponent } from './components/admin/data-delete/data-delete.component';


firebase.default.initializeApp(environment.firebaseConfig);
@NgModule({
  declarations: [
    AppComponent,
    RegistrationComponent,
    ChooseLangComponent,
    DrawSurfaceComponent,
    AgreeDialogComponent,
    InfoDialogComponent,
    LoaderComponent,
    SuccessComponent,
    LandingComponent,
    LoginComponent,
    ReportsMainComponent,
    MemberListComponent,
    MemberStatsComponent,
    AppMessagesComponent,
    MarketingChannelsComponent,
    MarketingChannelsDetailComponent,
    AppMessagesDetailComponent,
    MemberDetailComponent,
    TermsDetailsComponent,
    GdprDetailsComponent,
    MainDetailsComponent,
    DataDeleteComponent
  ],
  imports: [
    BrowserModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatMenuModule,
    MatTabsModule,
    MatPaginatorModule,
    MatTableModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatRadioModule,
    MatCheckboxModule,
    MatDividerModule,
    MatInputModule,
    MatCardModule,
    RouterModule,
    MatTreeModule,
    MatGridListModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatSortModule
  ],
   
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiErrorWarningInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
